import { Component, ErrorHandler, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { PagerBaseComponent, PagerModel } from '~/app/open-age/core/structures';
import { Report, ReportArea, ReportType } from '../models';
import { ReportDataService } from '../services/report-data.service';
import { ReportService } from '../services/report.service';

export class ReportDataBaseComponent extends PagerBaseComponent<any> implements OnInit, OnChanges {

  @Input()
  report: Report;

  @Input()
  reportType: ReportType;

  @Input()
  query: any;

  @Input()
  refreshSeconds = 0;

  @Input()
  view: 'table' | 'grid' | 'bars' | 'pie' = 'table';

  // @Output()
  // onClose: EventEmitter<any> = new EventEmitter<any>();

  // page: PagerModel<any>;

  headArray = [];

  summary: any = {};

  constructor(

    // private reportService: ReportService,
    api: ReportDataService,
    errorHandler: ErrorHandler
  ) {
    super({
      api,
      filters: ['reportId'],
      errorHandler,
      pageOptions: { limit: 10 }
    });
    // this.reportTypeCode = this.route.snapshot.paramMap.get('reportTypeCode');

  }
  ngOnInit(): void {
    this.reportType.columns.forEach((element) => {
      this.headArray.push(element.key);
    });
    // if (this.report.status === 'new' || this.report.status === 'in-progress') {
    //   setTimeout(() => {
    //     this.refresh();
    //   }, 5000);
    // }
    this.currentPageNo = 1;
    this.getData();
  }

  ngOnChanges(): void {
    // this.getData();
  }

  getData() {
    this.isProcessing = true;
    this.filters.properties['reportId'].value = this.report.id;
    this.fetch().subscribe(() => {
      this.isProcessing = false;
      this.report.items = this.items.length;
      if (this.stats) {
        Object.keys(this.stats).forEach((key) => {
          this.summary[key] = this.stats[key];
        });

        this.summary.hasValue = true;
      }
    });

    if (this.refreshSeconds) {
      setTimeout(() => {
        this.getData();
      }, this.refreshSeconds * 1000);
    }
  }

  // close() {
  //   this.report = null;
  //   this.onClose.emit()
  // }

  // generate() {
  //   this.reportService.update(this.report.id, { status: 'new' }).subscribe(report => {
  //     this.report = report
  //     if (this.report.status === 'new' || this.report.status === 'in-progress') {
  //       setTimeout(() => {
  //         this.refresh();
  //       }, 5000);
  //     }
  //   })
  // }

  // autoRefresh() {
  //   setTimeout(() => {
  //     this.getData();
  //   }, 15000);
  // }

  // refresh() {
  //   if (!this.report) {
  //     return;
  //   }
  //   this.reportService.get(this.report.id).subscribe(report => {
  //     this.report = report
  //     if (this.report.status === 'new' || this.report.status === 'in-progress') {
  //       setTimeout(() => {
  //         this.refresh();
  //       }, 5000);
  //     }
  //   })
  // }

  // download() {
  //   const a = document.createElement('a');
  //   document.body.appendChild(a);
  //   a.href = this.report.url;
  //   a.download = this.report.type.code;
  //   a.click();
  //   document.body.removeChild(a);
  // }
}
